export const authData = {
  login: {
    message: 'Inicio de sesión exitoso',
    access_token: {
      headers: {},
      original: {
        access_token:
          'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FiYXRoZXJhcHkubWFsY29sbWNvcmRvdmEuY29tL2JhY2tlbmQtYXBpLWFiYS9wdWJsaWMvYXBpL2xvZ2luIiwiaWF0IjoxNzI4OTIyNjYyLCJleHAiOjE3Mjg5MzM0NjIsIm5iZiI6MTcyODkyMjY2MiwianRpIjoiR2YxakpUV2NleHhXTWhiUCIsInN1YiI6IjEiLCJwcnYiOiIyM2JkNWM4OTQ5ZjYwMGFkYjM5ZTcwMWM0MDA4NzJkYjdhNTk3NmY3In0.rlCR-_7kx5w-W5Kv6HQCx0fQ7f_pwoAm1hB5nbfH3Mo',
        token_type: 'bearer',
        expires_in: 32400,
        user: {
          name: 'superadmin',
          surname: 'admin',
          email: 'superadmin@superadmin.com',
          permissions: [],
        },
      },
      exception: null,
    },
    token_type: 'Bearer',
    user: {
      id: 1,
      name: 'superadmin',
      surname: 'admin',
      avatar: 'staffs/QJCztYlLW8oU6IwCgatrtkH4UgeKpIcYoyfVo62Y.webp',
      roles: ['SUPERADMIN'],
      email: 'superadmin@superadmin.com',
      location_id: 4,
      permissions: [],
      two_factor_enabled: false,
    },
  },
  loginWith2FA: {
    message: 'Two-factor authentication required',
    two_factor_required: true,
    expires_in_minutes: 5,
    phone_hint: '**1234'
  },
  register: {
    result: false,
  },
};
